import { ProductColorType } from "types/ProductColorType";
import { API_URL, APP_NAME, INVOICE_URL, APP_LOGO, IMAGE_BASE_URL } from "./settings";

export const OrderStatusList = [
  { id: 1, title: "Order Placed", isCancelable:true},
  { id: 2, title: "Order Accepted", isCancelable:true},
  { id: 3, title: "Order Processing", isCancelable:true},
  { id: 4, title: "Order Shipped", isCancelable:false},
  { id: 5, title: "Order Delivered", isCancelable:false},
  { id: 6, title: "Order Completed", isCancelable:false},
  { id: 7, title: "Order Canceled", isCancelable:false},
  { id: 8, title: "Order Rejected", isCancelable:false}
];

export const GenderList = [
  { value: '', label: 'Select Gender' },
  { value: 'Boys', label: 'Boys' },
  { value: 'Girls', label: 'Girls' },
  { value: 'Unisex', label: 'Unisex' },
];

export const BusinessDocuments = [
  { id: 1, title: 'GST Registration Certificate' },
  { id: 2, title: 'PAN' },
  { id: 3, title: 'Aadhar' },
  { id: 4, title: 'Udyam Registration' },
];


export const ProductColors: any[] = [
  // Magenta Variants (kept all existing)
  {
    colorName: "Magenta Vivid",
    colorCode: "#FF00FF",
    categoryName: "Magenta",
    selected: false
  },
  {
    colorName: "Magenta Pale",
    colorCode: "#FFB6FF",
    categoryName: "Magenta",
    selected: false
  },
  {
    colorName: "Magenta Dark",
    colorCode: "#8B008B",
    categoryName: "Magenta",
    selected: false
  },
  {
    colorName: "Magenta Muted",
    colorCode: "#DDA0DD",
    categoryName: "Magenta",
    selected: false
  },

  // Red Variants (updated with your new red)
  {
    colorName: "Red",
    colorCode: "#ff0000",
    categoryName: "Red",
    selected: false
  },
  // Kept existing variant -- was Red Pale
  {
    colorName: "Pink",
    colorCode: "#ffc0cb",
    categoryName: "Red",
    selected: false
  },
  {
    colorName: "Red Dark",
    colorCode: "#8B0000",
    categoryName: "Red",
    selected: false
  },
  {
    colorName: "Red Muted",
    colorCode: "#CD5C5C",
    categoryName: "Red",
    selected: false
  },

    // Orange Variants (updated with your new orange)
    {
      colorName: "Orange",
      colorCode: "#ffa500",
      categoryName: "Orange",
      selected: false
    },
    // Kept existing variants
    {
      colorName: "Orange Pale",
      colorCode: "#FFDEAD",
      categoryName: "Orange",
      selected: false
    },
    {
      colorName: "Orange Dark",
      colorCode: "#FF8C00",
      categoryName: "Orange",
      selected: false
    },
    {
      colorName: "Orange Muted",
      colorCode: "#F4A460",
      categoryName: "Orange",
      selected: false
    },

    
  // Yellow Variants (updated with your new yellow and golden)
  {
    colorName: "Yellow",
    colorCode: "#ffff00",
    categoryName: "Yellow",
    selected: false
  },
  // {
  //   colorName: "Golden",
  //   colorCode: "#eab308",
  //   categoryName: "Yellow",
  //   selected: false
  // },
  // Kept existing variants
  {
    colorName: "Yellow Pale",
    colorCode: "#FFFFE0",
    categoryName: "Yellow",
    selected: false
  },
  {
    colorName: "Yellow Dark",
    colorCode: "#CCCC00",
    categoryName: "Yellow",
    selected: false
  },
  {
    colorName: "Yellow Muted",
    colorCode: "#F0E68C",
    categoryName: "Yellow",
    selected: false
  },

  // Lime Variants (kept all existing)
  {
    colorName: "Lime Vivid",
    colorCode: "#00FF00",
    categoryName: "Lime",
    selected: false
  },
  {
    colorName: "Lime Pale",
    colorCode: "#F0FFF0",
    categoryName: "Lime",
    selected: false
  },
  {
    colorName: "Lime Dark",
    colorCode: "#32CD32",
    categoryName: "Lime",
    selected: false
  },
  {
    colorName: "Lime Muted",
    colorCode: "#9ACD32",
    categoryName: "Lime",
    selected: false
  },

  // Green Variants (updated with your new green)
  {
    colorName: "Green",
    colorCode: "#008000",
    categoryName: "Green",
    selected: false
  },
  // Kept existing variants
  {
    colorName: "Green Pale",
    colorCode: "#98FB98",
    categoryName: "Green",
    selected: false
  },
  {
    colorName: "Green Dark",
    colorCode: "#006400",
    categoryName: "Green",
    selected: false
  },
  {
    colorName: "Green Muted",
    colorCode: "#6B8E23",
    categoryName: "Green",
    selected: false
  },

  // Cyan Variants (kept all existing)
  {
    colorName: "Cyan Vivid",
    colorCode: "#40E0D0",
    categoryName: "Cyan",
    selected: false
  },
  {
    colorName: "Cyan Pale",
    colorCode: "#AFEEEE",
    categoryName: "Cyan",
    selected: false
  },
  {
    colorName: "Cyan Dark",
    colorCode: "#008B8B",
    categoryName: "Cyan",
    selected: false
  },
  {
    colorName: "Cyan Muted",
    colorCode: "#5F9EA0",
    categoryName: "Cyan",
    selected: false
  },

  
  // Blue Variants (updated with your new blue)
  {
    colorName: "Blue",
    colorCode: "#0000ff",
    categoryName: "Blue",
    selected: false
  },
  // Kept existing variants
  {
    colorName: "Blue Pale",
    colorCode: "#ADD8E6",
    categoryName: "Blue",
    selected: false
  },
  {
    colorName: "Blue Dark",
    colorCode: "#00008B",
    categoryName: "Blue",
    selected: false
  },
  {
    colorName: "Blue Muted",
    colorCode: "#4682B4",
    categoryName: "Blue",
    selected: false
  },

  
  // Purple Variants (updated with your new purple)
  {
    colorName: "Purple",
    colorCode: "#800080",
    categoryName: "Purple",
    selected: false
  },
  // Kept existing variants
  {
    colorName: "Purple Pale",
    colorCode: "#E6E6FA",
    categoryName: "Purple",
    selected: false
  },
  {
    colorName: "Purple Dark",
    colorCode: "#9400D3",
    categoryName: "Purple",
    selected: false
  },
  {
    colorName: "Purple Muted",
    colorCode: "#9370DB",
    categoryName: "Purple",
    selected: false
  },


  
  // Brown (new color category)
  {
    colorName: "Brown",
    colorCode: "#a52a2a",
    categoryName: "Brown",
    selected: false
  },

  // Beige (new color category)
  {
    colorName: "Beige",
    colorCode: "#fbe0c5",
    categoryName: "Beige",
    selected: false
  },

  // Neutral Colors (new category)
  {
    colorName: "White",
    colorCode: "#ffffff",
    categoryName: "Neutral",
    selected: false
  },
  {
    colorName: "Gray",
    colorCode: "#eeeeee",
    categoryName: "Neutral",
    selected: false
  },
  {
    colorName: "Slate Gray",
    colorCode: "#6D8196",
    categoryName: "Neutral",
    selected: false
  },
  {
    colorName: "Black",
    colorCode: "#000000",
    categoryName: "Neutral",
    selected: false
  },

  {
    colorName: "Espresso",
    colorCode: "#3C2415",
    categoryName: "Earth Tones",
    selected: false
  },
  {
    colorName: "Coffee",
    colorCode: "#5D4037",
    categoryName: "Earth Tones",
    selected: false
  },
  {
    colorName: "Mocha",
    colorCode: "#8D6E63",
    categoryName: "Earth Tones",
    selected: false
  },
  {
    colorName: "Light Camel",
    colorCode: "#A1887F",
    categoryName: "Earth Tones",
    selected: false
  }

];

export const ProductColors3: any[] = [
      {
        colorName: "Magenta Vivid",
        colorCode: "#FF00FF",
        categoryName : "Magenta",
        selected: false
      },
      {
        colorName: "Red Vivid",
        colorCode: "#FF0000",
        categoryName : "Red",
        selected: false
      },
      {
        colorName: "Orange Vivid",
        colorCode: "#FFA500",
        categoryName : "Orange",
        selected: false
      },
      {
        colorName: "Yellow Vivid",
        colorCode: "#FFFF00",
        categoryName : "Yellow",
        selected: false
      },
      {
        colorName: "Lime Vivid",
        colorCode: "#00FF00",
        categoryName : "Lime",
        selected: false
      },
      {
        colorName: "Green Vivid",
        colorCode: "#008000",
        categoryName : "Green",
        selected: false
      },
      {
        colorName: "Cyan Vivid",
        colorCode: "#40E0D0",
        categoryName : "Cyna",
        selected: false
      },
      {
        colorName: "Blue Vivid",
        colorCode: "#0000FF",
        categoryName : "Blue",
        selected: false
      },
      {
        colorName: "Purple Vivid",
        colorCode: "#EE82EE",
        categoryName : "Purple",
        selected: false
      },
      {
        colorName: "Magenta Pale",
        colorCode: "#FFB6FF",
        categoryName : "Magenta",
        selected: false
      },
      {
        colorName: "Red Pale",
        colorCode: "#FFCCCB",
        categoryName : "Red",
        selected: false
      },
      {
        colorName: "Orange Pale",
        colorCode: "#FFDEAD",
        categoryName : "Orange",
        selected: false
      },
      {
        colorName: "Yellow Pale",
        colorCode: "#FFFFE0",
        categoryName : "Yellow",
        selected: false
      },
      {
        colorName: "Lime Pale",
        colorCode: "#F0FFF0",
        categoryName : "Lime",
        selected: false
      },
      {
        colorName: "Green Pale",
        colorCode: "#98FB98",
        categoryName : "Green",
        selected: false
      },
      {
        colorName: "Cyna Pale",
        colorCode: "#AFEEEE",
        categoryName : "Cyna",
        selected: false
      },
      {
        colorName: "Blue Pale",
        colorCode: "#ADD8E6",
        categoryName : "Blue",
        selected: false
      },
      {
        colorName: "Purple Pale",
        colorCode: "#E6E6FA",
        categoryName : "Purple",
        selected: false
      },
      {
        colorName: "Magenta Dark",
        colorCode: "#8B008B",
        categoryName : "Magenta",
        selected: false
      },
      {
        colorName: "Red Dark",
        colorCode: "#8B0000",
        categoryName : "Red",
        selected: false
      },
      {
        colorName: "Orange Dark",
        colorCode: "#FF8C00",
        categoryName : "Orange",
        selected: false
      },
      {
        colorName: "Yellow Dark",
        colorCode: "#CCCC00",
        categoryName : "Yellow",
        selected: false
      },
      {
        colorName: "Lime Dark",
        colorCode: "#32CD32",
        categoryName : "Lime",
        selected: false
      },
      {
        colorName: "Green Dark",
        colorCode: "#006400",
        categoryName : "Green",
        selected: false
      },
      {
        colorName: "Cyna Dark",
        colorCode: "#008B8B",
        categoryName : "Cyna",
        selected: false
      },
      {
        colorName: "Blue Dark",
        colorCode: "#00008B",
        categoryName : "Blue",
        selected: false
      },
      {
        colorName: "Purple Dark",
        colorCode: "#9400D3",
        categoryName : "Purple",
        selected: false
      },
      {
        colorName: "Magenta Muted",
        colorCode: "#DDA0DD",
        categoryName : "Magenta",
        selected: false
      },
      {
        colorName: "Red Muted",
        colorCode: "#CD5C5C",
        categoryName : "Red",
        selected: false
      },
      {
        colorName: "Orange Muted",
        colorCode: "#F4A460",
        categoryName : "Orange",
        selected: false
      },
      {
        colorName: "Yellow Muted",
        colorCode: "#F0E68C",
        categoryName : "Yellow",
        selected: false
      },
      {
        colorName: "Lime Muted",
        colorCode: "#9ACD32",
        categoryName : "Lime",
        selected: false
      },
      {
        colorName: "Green Muted",
        colorCode: "#6B8E23",
        categoryName : "Green",
        selected: false
      },
      {
        colorName: "Cyna Muted",
        colorCode: "#5F9EA0",
        categoryName : "Cyna",
        selected: false
      },
      {
        colorName: "Blue Muted",
        colorCode: "#4682B4",
        categoryName : "Blue",
        selected: false
      },
      {
        colorName: "Purple Muted",
        colorCode: "#9370DB",
        categoryName : "Purple",
        selected: false
      },

]

export const ProductColors2: any[] = [
  // Basic Colors
  { id: 1, colorCode: '#000000', colorName: 'Black', category: 'Basic', selected: false },
  { id: 2, colorCode: '#ffffff', colorName: 'White', category: 'Basic', selected: false },
  { id: 3, colorCode: '#808080', colorName: 'Gray', category: 'Basic', selected: false },
  { id: 4, colorCode: '#d3d3d3', colorName: 'Light Gray', category: 'Basic', selected: false },
  { id: 5, colorCode: '#a9a9a9', colorName: 'Dark Gray', category: 'Basic', selected: false },
  { id: 6, colorCode: '#36454f', colorName: 'Charcoal', category: 'Basic', selected: false },
  { id: 7, colorCode: '#c0c0c0', colorName: 'Silver', category: 'Basic', selected: false },
  { id: 8, colorCode: '#708090', colorName: 'Slate Gray', category: 'Basic', selected: false },

  // Blue Colors
  { id: 9, colorCode: '#000080', colorName: 'Navy Blue', category: 'Blue', selected: false },
  { id: 10, colorCode: '#4169e1', colorName: 'Royal Blue', category: 'Blue', selected: false },
  { id: 11, colorCode: '#0000ff', colorName: 'Blue', category: 'Blue', selected: false },
  { id: 12, colorCode: '#87ceeb', colorName: 'Sky Blue', category: 'Blue', selected: false },
  { id: 13, colorCode: '#b0e0e6', colorName: 'Powder Blue', category: 'Blue', selected: false },
  { id: 14, colorCode: '#008080', colorName: 'Teal', category: 'Blue', selected: false },
  { id: 15, colorCode: '#40e0d0', colorName: 'Turquoise', category: 'Blue', selected: false },
  { id: 16, colorCode: '#1560bd', colorName: 'Denim Blue', category: 'Blue', selected: false },
  { id: 17, colorCode: '#4682b4', colorName: 'Steel Blue', category: 'Blue', selected: false },
  { id: 18, colorCode: '#191970', colorName: 'Midnight Blue', category: 'Blue', selected: false },
  { id: 19, colorCode: '#0047ab', colorName: 'Cobalt Blue', category: 'Blue', selected: false },
  { id: 20, colorCode: '#b6d0e2', colorName: 'Ice Blue', category: 'Blue', selected: false },
  { id: 21, colorCode: '#00ffff', colorName: 'Aqua', category: 'Blue', selected: false },

  // Red Colors
  { id: 22, colorCode: '#ff0000', colorName: 'Red', category: 'Red', selected: false },
  { id: 23, colorCode: '#800020', colorName: 'Burgundy', category: 'Red', selected: false },
  { id: 24, colorCode: '#800000', colorName: 'Maroon', category: 'Red', selected: false },
  { id: 25, colorCode: '#dc143c', colorName: 'Crimson', category: 'Red', selected: false },
  { id: 26, colorCode: '#de3163', colorName: 'Cherry Red', category: 'Red', selected: false },
  { id: 27, colorCode: '#722f37', colorName: 'Wine', category: 'Red', selected: false },
  { id: 28, colorCode: '#cb4154', colorName: 'Brick Red', category: 'Red', selected: false },
  { id: 29, colorCode: '#e0115f', colorName: 'Ruby Red', category: 'Red', selected: false },
  { id: 30, colorCode: '#ff2400', colorName: 'Scarlet', category: 'Red', selected: false },
  { id: 31, colorCode: '#c41e3a', colorName: 'Cardinal Red', category: 'Red', selected: false },

  // Green Colors
  { id: 32, colorCode: '#008000', colorName: 'Green', category: 'Green', selected: false },
  { id: 33, colorCode: '#228b22', colorName: 'Forest Green', category: 'Green', selected: false },
  { id: 34, colorCode: '#808000', colorName: 'Olive Green', category: 'Green', selected: false },
  { id: 35, colorCode: '#9caf88', colorName: 'Sage Green', category: 'Green', selected: false },
  { id: 36, colorCode: '#98fb98', colorName: 'Mint Green', category: 'Green', selected: false },
  { id: 37, colorCode: '#50c878', colorName: 'Emerald Green', category: 'Green', selected: false },
  { id: 38, colorCode: '#355e3b', colorName: 'Hunter Green', category: 'Green', selected: false },
  { id: 39, colorCode: '#01796f', colorName: 'Pine Green', category: 'Green', selected: false },
  { id: 40, colorCode: '#32cd32', colorName: 'Lime Green', category: 'Green', selected: false },
  { id: 41, colorCode: '#4cbb17', colorName: 'Kelly Green', category: 'Green', selected: false },
  { id: 42, colorCode: '#93e9be', colorName: 'Seafoam Green', category: 'Green', selected: false },

  // Yellow Colors
  { id: 43, colorCode: '#ffff00', colorName: 'Yellow', category: 'Yellow', selected: false },
  { id: 44, colorCode: '#ffdb58', colorName: 'Mustard Yellow', category: 'Yellow', selected: false },
  { id: 45, colorCode: '#ffd700', colorName: 'Gold', category: 'Yellow', selected: false },
  { id: 46, colorCode: '#eab308', colorName: 'Golden', category: 'Yellow', selected: false },
  { id: 47, colorCode: '#fffdd0', colorName: 'Cream', category: 'Yellow', selected: false },
  { id: 48, colorCode: '#f7e7ce', colorName: 'Champagne', category: 'Yellow', selected: false },
  { id: 49, colorCode: '#fff700', colorName: 'Lemon Yellow', category: 'Yellow', selected: false },
  { id: 50, colorCode: '#fffd74', colorName: 'Butter Yellow', category: 'Yellow', selected: false },
  { id: 51, colorCode: '#ffef00', colorName: 'Canary Yellow', category: 'Yellow', selected: false },

  // Purple Colors
  { id: 52, colorCode: '#800080', colorName: 'Purple', category: 'Purple', selected: false },
  { id: 53, colorCode: '#e6e6fa', colorName: 'Lavender', category: 'Purple', selected: false },
  { id: 54, colorCode: '#dda0dd', colorName: 'Plum', category: 'Purple', selected: false },
  { id: 55, colorCode: '#8a2be2', colorName: 'Violet', category: 'Purple', selected: false },
  { id: 56, colorCode: '#e0b0ff', colorName: 'Mauve', category: 'Purple', selected: false },
  { id: 57, colorCode: '#4b0082', colorName: 'Indigo', category: 'Purple', selected: false },
  { id: 58, colorCode: '#c8a2c8', colorName: 'Lilac', category: 'Purple', selected: false },
  { id: 59, colorCode: '#da70d6', colorName: 'Orchid', category: 'Purple', selected: false },
  { id: 60, colorCode: '#9966cc', colorName: 'Amethyst', category: 'Purple', selected: false },

  // Brown Colors
  { id: 61, colorCode: '#a52a2a', colorName: 'Brown', category: 'Brown', selected: false },
  { id: 62, colorCode: '#d2b48c', colorName: 'Tan', category: 'Brown', selected: false },
  { id: 63, colorCode: '#f5f5dc', colorName: 'Beige', category: 'Brown', selected: false },
  { id: 64, colorCode: '#fbe0c5', colorName: 'Light Beige', category: 'Brown', selected: false },
  { id: 65, colorCode: '#f0e68c', colorName: 'Khaki', category: 'Brown', selected: false },
  { id: 66, colorCode: '#c19a6b', colorName: 'Camel', category: 'Brown', selected: false },
  { id: 67, colorCode: '#d2691e', colorName: 'Chocolate', category: 'Brown', selected: false },
  { id: 68, colorCode: '#483c32', colorName: 'Taupe', category: 'Brown', selected: false },
  { id: 69, colorCode: '#6f4e37', colorName: 'Coffee', category: 'Brown', selected: false },
  { id: 70, colorCode: '#967117', colorName: 'Mocha', category: 'Brown', selected: false },
  { id: 71, colorCode: '#954535', colorName: 'Chestnut', category: 'Brown', selected: false },

  // Pink Colors
  { id: 72, colorCode: '#ffc0cb', colorName: 'Pink', category: 'Pink', selected: false },
  { id: 73, colorCode: '#ff69b4', colorName: 'Hot Pink', category: 'Pink', selected: false },
  { id: 74, colorCode: '#ff007f', colorName: 'Rose', category: 'Pink', selected: false },
  { id: 75, colorCode: '#de5d83', colorName: 'Blush', category: 'Pink', selected: false },
  { id: 76, colorCode: '#ff7f50', colorName: 'Coral', category: 'Pink', selected: false },
  { id: 77, colorCode: '#fa8072', colorName: 'Salmon', category: 'Pink', selected: false },
  { id: 78, colorCode: '#dcae96', colorName: 'Dusty Rose', category: 'Pink', selected: false },
  { id: 79, colorCode: '#ff00ff', colorName: 'Fuchsia', category: 'Pink', selected: false },
  { id: 80, colorCode: '#ff00ff', colorName: 'Magenta', category: 'Pink', selected: false },

  // Orange Colors
  { id: 81, colorCode: '#ffa500', colorName: 'Orange', category: 'Orange', selected: false },
  { id: 82, colorCode: '#ffcba4', colorName: 'Peach', category: 'Orange', selected: false },
  { id: 83, colorCode: '#b7410e', colorName: 'Rust', category: 'Orange', selected: false },
  { id: 84, colorCode: '#cc5500', colorName: 'Burnt Orange', category: 'Orange', selected: false },
  { id: 85, colorCode: '#fbceb1', colorName: 'Apricot', category: 'Orange', selected: false },
  { id: 86, colorCode: '#f28500', colorName: 'Tangerine', category: 'Orange', selected: false },
  { id: 87, colorCode: '#ffefd5', colorName: 'Papaya', category: 'Orange', selected: false },

  // Neutral Colors
  { id: 88, colorCode: '#fffff0', colorName: 'Ivory', category: 'Neutral', selected: false },
  { id: 89, colorCode: '#faf0e6', colorName: 'Off White', category: 'Neutral', selected: false },
  { id: 90, colorCode: '#e3dac9', colorName: 'Bone', category: 'Neutral', selected: false },
  { id: 91, colorCode: '#eae0c8', colorName: 'Pearl', category: 'Neutral', selected: false },
  { id: 92, colorCode: '#b2beb5', colorName: 'Ash Gray', category: 'Neutral', selected: false },
  { id: 93, colorCode: '#928e85', colorName: 'Stone', category: 'Neutral', selected: false },
  { id: 94, colorCode: '#c2b280', colorName: 'Sand', category: 'Neutral', selected: false },

  // Metallic Colors
  { id: 95, colorCode: '#b87333', colorName: 'Copper', category: 'Metallic', selected: false },
  { id: 96, colorCode: '#cd7f32', colorName: 'Bronze', category: 'Metallic', selected: false },
  { id: 97, colorCode: '#e8b4b8', colorName: 'Rose Gold', category: 'Metallic', selected: false },
  { id: 98, colorCode: '#2c3539', colorName: 'Gunmetal', category: 'Metallic', selected: false },
  { id: 99, colorCode: '#e5e4e2', colorName: 'Platinum', category: 'Metallic', selected: false },

  // Pastel Colors
  { id: 100, colorCode: '#ccccff', colorName: 'Periwinkle', category: 'Pastel', selected: false },
  { id: 101, colorCode: '#89cff0', colorName: 'Baby Blue', category: 'Pastel', selected: false },
  { id: 102, colorCode: '#f4c2c2', colorName: 'Baby Pink', category: 'Pastel', selected: false },
  { id: 103, colorCode: '#3eb489', colorName: 'Mint', category: 'Pastel', selected: false },
  { id: 104, colorCode: '#f3e5ab', colorName: 'Vanilla', category: 'Pastel', selected: false },
];

export const ProductColors1: any[] = [

  // Red
      // { colorCode: '#ff7f7f', colorName: 'Light Red', selected: false },
      { colorCode: '#ff0000', colorName: 'Red', selected: false },
      // { colorCode: '#8b0000', colorName: 'Deep Red', selected: false },
    
      // Blue
      // { colorCode: '#add8e6', colorName: 'Light Blue', selected: false },
      { colorCode: '#0000ff', colorName: 'Blue', selected: false },
      // { colorCode: '#00008b', colorName: 'Deep Blue', selected: false },
    
      // Green
      // { colorCode: '#90ee90', colorName: 'Light Green', selected: false },
      { colorCode: '#008000', colorName: 'Green', selected: false },
      // { colorCode: '#006400', colorName: 'Deep Green', selected: false },
    
      // Yellow
      // { colorCode: '#ffffe0', colorName: 'Light Yellow', selected: false },
      { colorCode: '#ffff00', colorName: 'Yellow', selected: false },
      // { colorCode: '#ffcc00', colorName: 'Deep Yellow', selected: false },
      { colorCode: '#eab308', colorName: 'Golden', selected: false },

      // Beige
      { colorCode: '#fbe0c5', colorName: 'Beige', selected: false },

      // Orange
      // { colorCode: '#ffd699', colorName: 'Light Orange', selected: false },
      { colorCode: '#ffa500', colorName: 'Orange', selected: false },
      // { colorCode: '#cc5500', colorName: 'Deep Orange', selected: false },
    
      // Pink
      // { colorCode: '#ffb6c1', colorName: 'Light Pink', selected: false },
      { colorCode: '#ffc0cb', colorName: 'Pink', selected: false },
      // { colorCode: '#ff1493', colorName: 'Deep Pink', selected: false },
    
      // Brown
      // { colorCode: '#d2b48c', colorName: 'Light Brown', selected: false },
      { colorCode: '#a52a2a', colorName: 'Brown', selected: false },
      // { colorCode: '#654321', colorName: 'Deep Brown', selected: false },
    
      // Purple
      // { colorCode: '#c8a2c8', colorName: 'Light Purple', selected: false },
      { colorCode: '#800080', colorName: 'Purple', selected: false },
      //{ colorCode: '#4b0082', colorName: 'Deep Purple', selected: false },

      { colorCode: '#ffffff', colorName: 'White', selected: false },
      { colorCode: '#eeeeee', colorName: 'Gray', selected: false },
      // { colorCode: '#FAF9F6', colorName: 'Snow', selected: false },
      { colorCode: '#000000', colorName: 'Black', selected: false },
    ];

    // Merge FabricColors into ProductColors, skipping duplicates by colorCode (case-insensitive)
    const fabricColorsRaw = [
        { "id": 1, "name": "Black", "hex": "#000000", "category": "Basic" },
        { "id": 2, "name": "White", "hex": "#FFFFFF", "category": "Basic" },
        { "id": 3, "name": "Gray", "hex": "#808080", "category": "Basic" },
        { "id": 4, "name": "Light Gray", "hex": "#D3D3D3", "category": "Basic" },
        { "id": 5, "name": "Dark Gray", "hex": "#A9A9A9", "category": "Basic" },
        { "id": 6, "name": "Charcoal", "hex": "#36454F", "category": "Basic" },
        { "id": 7, "name": "Silver", "hex": "#C0C0C0", "category": "Basic" },
        { "id": 8, "name": "Slate Gray", "hex": "#708090", "category": "Basic" },
        { "id": 9, "name": "Navy Blue", "hex": "#000080", "category": "Blue" },
        { "id": 10, "name": "Royal Blue", "hex": "#4169E1", "category": "Blue" },
        { "id": 11, "name": "Sky Blue", "hex": "#87CEEB", "category": "Blue" },
        { "id": 12, "name": "Powder Blue", "hex": "#B0E0E6", "category": "Blue" },
        { "id": 13, "name": "Teal", "hex": "#008080", "category": "Blue" },
        { "id": 14, "name": "Turquoise", "hex": "#40E0D0", "category": "Blue" },
        { "id": 15, "name": "Denim Blue", "hex": "#1560BD", "category": "Blue" },
        { "id": 16, "name": "Steel Blue", "hex": "#4682B4", "category": "Blue" },
        { "id": 17, "name": "Midnight Blue", "hex": "#191970", "category": "Blue" },
        { "id": 18, "name": "Cobalt Blue", "hex": "#0047AB", "category": "Blue" },
        { "id": 19, "name": "Ice Blue", "hex": "#B6D0E2", "category": "Blue" },
        { "id": 20, "name": "Aqua", "hex": "#00FFFF", "category": "Blue" },
        { "id": 21, "name": "Red", "hex": "#FF0000", "category": "Red" },
        { "id": 22, "name": "Burgundy", "hex": "#800020", "category": "Red" },
        { "id": 23, "name": "Maroon", "hex": "#800000", "category": "Red" },
        { "id": 24, "name": "Crimson", "hex": "#DC143C", "category": "Red" },
        { "id": 25, "name": "Cherry Red", "hex": "#DE3163", "category": "Red" },
        { "id": 26, "name": "Wine", "hex": "#722F37", "category": "Red" },
        { "id": 27, "name": "Brick Red", "hex": "#CB4154", "category": "Red" },
        { "id": 28, "name": "Ruby Red", "hex": "#E0115F", "category": "Red" },
        { "id": 29, "name": "Scarlet", "hex": "#FF2400", "category": "Red" },
        { "id": 30, "name": "Cardinal Red", "hex": "#C41E3A", "category": "Red" },
        { "id": 31, "name": "Forest Green", "hex": "#228B22", "category": "Green" },
        { "id": 32, "name": "Olive Green", "hex": "#808000", "category": "Green" },
        { "id": 33, "name": "Sage Green", "hex": "#9CAF88", "category": "Green" },
        { "id": 34, "name": "Mint Green", "hex": "#98FB98", "category": "Green" },
        { "id": 35, "name": "Emerald Green", "hex": "#50C878", "category": "Green" },
        { "id": 36, "name": "Hunter Green", "hex": "#355E3B", "category": "Green" },
        { "id": 37, "name": "Pine Green", "hex": "#01796F", "category": "Green" },
        { "id": 38, "name": "Lime Green", "hex": "#32CD32", "category": "Green" },
        { "id": 39, "name": "Kelly Green", "hex": "#4CBB17", "category": "Green" },
        { "id": 40, "name": "Seafoam Green", "hex": "#93E9BE", "category": "Green" },
        { "id": 41, "name": "Yellow", "hex": "#FFFF00", "category": "Yellow" },
        { "id": 42, "name": "Mustard Yellow", "hex": "#FFDB58", "category": "Yellow" },
        { "id": 43, "name": "Gold", "hex": "#FFD700", "category": "Yellow" },
        { "id": 44, "name": "Cream", "hex": "#FFFDD0", "category": "Yellow" },
        { "id": 45, "name": "Champagne", "hex": "#F7E7CE", "category": "Yellow" },
        { "id": 46, "name": "Lemon Yellow", "hex": "#FFF700", "category": "Yellow" },
        { "id": 47, "name": "Butter Yellow", "hex": "#FFFD74", "category": "Yellow" },
        { "id": 48, "name": "Canary Yellow", "hex": "#FFEF00", "category": "Yellow" },
        { "id": 49, "name": "Purple", "hex": "#800080", "category": "Purple" },
        { "id": 50, "name": "Lavender", "hex": "#E6E6FA", "category": "Purple" },
        { "id": 51, "name": "Plum", "hex": "#DDA0DD", "category": "Purple" },
        { "id": 52, "name": "Violet", "hex": "#8A2BE2", "category": "Purple" },
        { "id": 53, "name": "Mauve", "hex": "#E0B0FF", "category": "Purple" },
        { "id": 54, "name": "Indigo", "hex": "#4B0082", "category": "Purple" },
        { "id": 55, "name": "Lilac", "hex": "#C8A2C8", "category": "Purple" },
        { "id": 56, "name": "Orchid", "hex": "#DA70D6", "category": "Purple" },
        { "id": 57, "name": "Amethyst", "hex": "#9966CC", "category": "Purple" },
        { "id": 58, "name": "Brown", "hex": "#A52A2A", "category": "Brown" },
        { "id": 59, "name": "Tan", "hex": "#D2B48C", "category": "Brown" },
        { "id": 60, "name": "Beige", "hex": "#F5F5DC", "category": "Brown" },
        { "id": 61, "name": "Khaki", "hex": "#F0E68C", "category": "Brown" },
        { "id": 62, "name": "Camel", "hex": "#C19A6B", "category": "Brown" },
        { "id": 63, "name": "Chocolate", "hex": "#D2691E", "category": "Brown" },
        { "id": 64, "name": "Taupe", "hex": "#483C32", "category": "Brown" },
        { "id": 65, "name": "Coffee", "hex": "#6F4E37", "category": "Brown" },
        { "id": 66, "name": "Mocha", "hex": "#967117", "category": "Brown" },
        { "id": 67, "name": "Chestnut", "hex": "#954535", "category": "Brown" },
        { "id": 68, "name": "Pink", "hex": "#FFC0CB", "category": "Pink" },
        { "id": 69, "name": "Hot Pink", "hex": "#FF69B4", "category": "Pink" },
        { "id": 70, "name": "Rose", "hex": "#FF007F", "category": "Pink" },
        { "id": 71, "name": "Blush", "hex": "#DE5D83", "category": "Pink" },
        { "id": 72, "name": "Coral", "hex": "#FF7F50", "category": "Pink" },
        { "id": 73, "name": "Salmon", "hex": "#FA8072", "category": "Pink" },
        { "id": 74, "name": "Dusty Rose", "hex": "#DCAE96", "category": "Pink" },
        { "id": 75, "name": "Fuchsia", "hex": "#FF00FF", "category": "Pink" },
        { "id": 76, "name": "Magenta", "hex": "#FF00FF", "category": "Pink" },
        { "id": 77, "name": "Orange", "hex": "#FFA500", "category": "Orange" },
        { "id": 78, "name": "Peach", "hex": "#FFCBA4", "category": "Orange" },
        { "id": 79, "name": "Rust", "hex": "#B7410E", "category": "Orange" },
        { "id": 80, "name": "Burnt Orange", "hex": "#CC5500", "category": "Orange" },
        { "id": 81, "name": "Apricot", "hex": "#FBCEB1", "category": "Orange" },
        { "id": 82, "name": "Tangerine", "hex": "#F28500", "category": "Orange" },
        { "id": 83, "name": "Papaya", "hex": "#FFEFD5", "category": "Orange" },
        { "id": 84, "name": "Ivory", "hex": "#FFFFF0", "category": "Neutral" },
        { "id": 85, "name": "Off White", "hex": "#FAF0E6", "category": "Neutral" },
        { "id": 86, "name": "Bone", "hex": "#E3DAC9", "category": "Neutral" },
        { "id": 87, "name": "Pearl", "hex": "#EAE0C8", "category": "Neutral" },
        { "id": 88, "name": "Ash Gray", "hex": "#B2BEB5", "category": "Neutral" },
        { "id": 89, "name": "Stone", "hex": "#928E85", "category": "Neutral" },
        { "id": 90, "name": "Sand", "hex": "#C2B280", "category": "Neutral" },
        { "id": 91, "name": "Copper", "hex": "#B87333", "category": "Metallic" },
        { "id": 92, "name": "Bronze", "hex": "#CD7F32", "category": "Metallic" },
        { "id": 93, "name": "Rose Gold", "hex": "#E8B4B8", "category": "Metallic" },
        { "id": 94, "name": "Gunmetal", "hex": "#2C3539", "category": "Metallic" },
        { "id": 95, "name": "Platinum", "hex": "#E5E4E2", "category": "Metallic" },
        { "id": 96, "name": "Periwinkle", "hex": "#CCCCFF", "category": "Pastel" },
        { "id": 97, "name": "Baby Blue", "hex": "#89CFF0", "category": "Pastel" },
        { "id": 98, "name": "Baby Pink", "hex": "#F4C2C2", "category": "Pastel" },
        { "id": 99, "name": "Mint", "hex": "#3EB489", "category": "Pastel" },
        { "id": 100, "name": "Vanilla", "hex": "#F3E5AB", "category": "Pastel" }
    ];


// export const appName = "Arolisa";
export const appName = APP_NAME;
export const apiURL = API_URL;
export const invoiceURL = INVOICE_URL;
export const logo = APP_LOGO;
export const NO_PRODUCT_IMAGE = 'assets/images/no-product-image.png';
type ImageType = 'productFull' | 'productThumbnail' | 'brandFull' | 'brandThumbnail' | 'profile' | 'categoryFull' | 'categoryThumbnail'| 'businessDocument' | 'bannerThumbnail' | 'bannerFull';

export const getImageUrl = (url: string | undefined = '', type: ImageType = 'productThumbnail') => {
    const urlParts = url.split("/");
    const fileName = urlParts?.pop()?.replace(".png", ".webp").replace(".jpg", ".webp").replace(".jpeg", ".webp");
    return IMAGE_BASE_URL[type] + (fileName || NO_PRODUCT_IMAGE);
}